/**
 * Constants for environment-aware WhatsApp ticket links.
 * Used by API (template variable {{3}}) and web (resolver redirect).
 */
export const WHATSAPP_TICKET_LINK_ENV_CODES = {
    production: 'prd',
    staging: 'stg',
};
export const WHATSAPP_TICKET_LINK_DOMAINS = {
    production: 'https://app.folw.eu',
    staging: 'https://staging.folw.eu',
};
/** API domains for webhook forwarding between environments */
export const WHATSAPP_TICKET_LINK_API_DOMAINS = {
    production: 'https://api.folw.eu',
    staging: 'https://staging.folw.eu',
};
/** Allowed env code prefixes in encoded ref (e.g. prd_, stg_) */
export const WHATSAPP_TICKET_LINK_ENV_CODE_VALUES = Object.values(WHATSAPP_TICKET_LINK_ENV_CODES);
/** UUID v4 regex (simple) for validation */
export const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
